import React from "react";

export const CasesLow = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66667 0C7.54215 0 8.40905 0.172438 9.21789 0.50747C10.0267 0.842501 10.7617 1.33356 11.3807 1.95262C11.9998 2.57168 12.4908 3.30661 12.8259 4.11544C13.1609 4.92428 13.3333 5.79119 13.3333 6.66667C13.3333 8.43478 12.631 10.1305 11.3807 11.3807C10.1305 12.631 8.43478 13.3333 6.66667 13.3333C5.79119 13.3333 4.92428 13.1609 4.11544 12.8259C3.30661 12.4908 2.57168 11.9998 1.95262 11.3807C0.702379 10.1305 0 8.43478 0 6.66667C0 4.89856 0.702379 3.20286 1.95262 1.95262C3.20286 0.702379 4.89856 0 6.66667 0ZM6.66667 10L10 6.66667H8V4H5.33333V6.66667H3.33333L6.66667 10Z"
        fill="#05F0A5"
      />
    </svg>
  );
};

export default CasesLow;
